import { inject, Injectable } from '@angular/core';
import { HttpService } from './http-service';
import { FaqDto } from '../dto/FaqDto';
import { AuthService } from './auth-service';

@Injectable({
  providedIn: 'root',
})
export class OpenService {

  private httpService: HttpService = inject(HttpService);
      private authService: AuthService = inject(AuthService);

  private readonly openSubPath = '/open';

  async getFaqData() : Promise<FaqDto> {
    this.authService.askToRefreshIfNeeded();
    return this.httpService.getToPromise<FaqDto>(`${this.openSubPath}/getFaq`);
  }
  
}
